import { createSlice } from '@reduxjs/toolkit'

import { getCustomersAPI } from '@/api/customersApi'
import { getCustomerStatusTextId } from '@/util/customers'
import { applyTextFilter, getFilteredList } from '@/util/misc'

import { getMessage } from './i18nReducer'

export const NAME = 'customers'

const LIST_ROW_RENDER_STEP = 50

export const createCustomer = ({
  id,
  name,
  orgNumber,
  vatNumber,
  customerHeadId = 0,
  customerHeadName,
  ...restOfProps
}: any) => ({
  id,
  name,
  orgNumber,
  vatNumber,
  customerHeadId,
  customerHeadName,
  ...restOfProps,
})

export const createCustomerHead = ({ id, name }: any) => ({
  id,
  name,
})
// @ts-ignore
export const fetchCustomers = () => async (dispatch, getState) => {
  const isPending = getIsPending(getState())
  if (isPending) return

  dispatch(loadPending())

  try {
    const result = await getCustomersAPI()

    dispatch(loadSuccess(result))
  } catch (error) {
    dispatch(loadFailure('Could not load your customers'))
  }
}

const initialState = {
  pending: false,
  isDataLoaded: false,
  error: undefined,
  customers: [],
  customerHeads: [],
  listRenderLimit: 70,
  textFilter: '',
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    loadPending: state => {
      state.error = undefined
      state.pending = true
    },
    loadSuccess: (state, { payload }) => {
      const { customers, customerHeads } = payload
      state.pending = false
      state.isDataLoaded = true
      state.customers = customers
      state.customerHeads = customerHeads
    },
    loadFailure: (state, { payload: error }) => {
      state.pending = false
      state.isDataLoaded = true
      state.error = error
    },
    setTextFilter: (state, { payload: textFilter }) => {
      state.textFilter = textFilter
      state.listRenderLimit = initialState.listRenderLimit
    },
    increaseListRenderLimit: state => {
      state.listRenderLimit = state.listRenderLimit + LIST_ROW_RENDER_STEP
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const {
  loadPending,
  loadSuccess,
  loadFailure,
  setTextFilter,
  increaseListRenderLimit,
  reset,
} = actions

export default reducer

const getState = (state: any) => state[NAME]

export const getIsPending = (state: any) => getState(state).pending
export const getError = (state: any) => getState(state).error
export const getIsDataLoaded = (state: any) => getState(state).isDataLoaded

export const getCustomers = (state: any) =>
  getState(state).customers.map((customer: any) => ({
    ...customer,
    customerStatusText: getMessage(state, getCustomerStatusTextId(customer.customerStatus)),
  }))
export const getFilteredCustomers = (state: any) => getFilteredList(state, getCustomers, textFilter)

export const getListRenderLimit = (state: any) => getState(state).listRenderLimit
export const getNumberOfCustomers = (state: any) => getFilteredCustomers(state).length
export const getVisibleCustomers = (state: any) =>
  getFilteredCustomers(state).slice(0, getListRenderLimit(state))
export const getCustomerListExceedsLimit = (state: any) =>
  getListRenderLimit(state) < getNumberOfCustomers(state)

export const getTextFilter = (state: any) => getState(state).textFilter
// @ts-ignore
const textFilter = (state, customers) =>
  applyTextFilter(
    customers,
    getTextFilter(state),
    customer =>
      `${customer.name}${customer.customerHeadName}${customer.orgNumber}${customer.address1}${customer.address2}${customer.zip}${customer.city}${customer.whitelabelName}${customer.customerStatusText}`
  )

export const getCustomerHeads = (state: any) => getState(state).customerHeads
// @ts-ignore
export const getCustomerFromId = (state, id) =>
  // @ts-ignore
  getCustomers(state).find(customer => customer.id === id)
